import { setModal } from '../../../../app/store/reducers/AppSlice'
import { IconCrown } from '../../icons/IconCrown'
import { BpTooltip } from '../../cards/tooltip/BpTooltip'
import { BpButton } from '../bp-button/BpButton'
import React from 'react'
import { useAppDispatch, useAppSelector } from '../../../../app/store/hooks/Redux'
import { selectTariffDetails } from '../../../../app/store/reducers/AuthSlice'
import { useTranslation } from 'react-i18next'
import { ViewGuard } from '../../../../app/guards/ViewGuard'
import { TariffDetailsModal } from '../../../../pages/projects/widgets/tariff-details-modal/TariffDetailsModal'
import { ChangeTariff } from '../../utility/change-tariff/ChangeTariff'

export const TariffButton = () => {
  const { t } = useTranslation()
  const tariffDetails = useAppSelector(selectTariffDetails)
  const dispatch = useAppDispatch()

  return (
    <ViewGuard roles={['editor', 'admin']}>
      <BpButton
        iconLeft={
          <IconCrown
            color={tariffDetails.tariff?.is_subscription_expired ? '#FFFFFF' : '#A059FF'}
          />
        }
        iconRight={
          !tariffDetails.tariff?.is_subscription_expired && (
            <BpTooltip color={'#A059FF'} title={t('pages.tariff.keywordsTooltip')} />
          )
        }
        className={`${tariffDetails.tariff?.is_subscription_expired && '!bg-[#FF4980]'}`}
        size={'sm'}
        theme={'light'}
        onClick={() =>
          tariffDetails.tariff?.is_subscription_expired
            ? dispatch(
                setModal({
                  size: 'full',
                  children: <ChangeTariff />,
                  withBackButton: true,
                }),
              )
            : dispatch(
                setModal({
                  children: <TariffDetailsModal />,
                }),
              )
        }
      >
        {tariffDetails.tariff?.is_subscription_expired ? (
          <span className={'text-white'}>
            {t('pages.tariff.tariffExpired', { tariff: tariffDetails.tariff?.name })}
          </span>
        ) : (
          <div className={'font-medium'}>
            {t('pages.tariff.used')}{' '}
            <span className={'font-bold'}>
              {tariffDetails.tariff?.used_keywords_count}/{tariffDetails.tariff?.max_keywords}
            </span>{' '}
            {t('pages.tariff.keywords')}
          </div>
        )}
      </BpButton>
    </ViewGuard>
  )
}
